import {
  UpdateTicketRequest,
  UpdateTicketResponse,
  UpdateTicketStatusMemoRequest,
  UpdateTicketStatusMemoResponse,
  ticketRestResource,
} from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";
import { GetInfraTaskTicketRequest } from "./get-infra-task-ticket/GetInfraTaskRequest";
import { GetInfraTaskTicketResponse } from "./get-infra-task-ticket/GetInfraTaskResponse";

export const useUpdateTicket = () =>
  useRestResourceHook<UpdateTicketRequest, UpdateTicketResponse>((request) =>
    ticketRestResource.updateTicket(request),
  );

export const useUpdateInfraTaskTicket = () =>
  useRestResourceHook<UpdateTicketRequest, UpdateTicketResponse>((request) =>
    ticketRestResource.updateInfraTaskTicket(request),
  );

export const useGetInfraTaskTicket = () =>
  useRestResourceHook<GetInfraTaskTicketRequest, GetInfraTaskTicketResponse>(
    (request) => ticketRestResource.getInfraTaskTicket(request),
  );

export const useUpdateTicketStatusMemo = () =>
  useRestResourceHook<
    UpdateTicketStatusMemoRequest,
    UpdateTicketStatusMemoResponse
  >((request) => ticketRestResource.updateTicketStatusMemo(request));
